"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  INITIAL: 'INITIAL',
  MEETING: 'MEETING',
  CALL: 'CALL',
  CHAT: 'CHAT',
  EMAIL: 'EMAIL'
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/communicationMethods/communicationMethodTypes.js
// module id = 319
// module chunks = 5 6